/* eslint-disable no-undef */
export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  function modifyTitle() {
    const span = document.querySelector('#seoWidget .card-widget-title');
    const h1 = document.createElement('h1');
    h1.textContent = span.textContent;
    span.parentNode.replaceChild(h1, span);
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      modifyTitle();
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
